import { Button, List } from "antd";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useIntl } from "react-intl";
import { PlusSVG, RightSVG } from "../../assets/onboarding/SVGs";

const PriceCard = ({
  title,
  name,
  feats,
  commissions = false,
  price = false,
  recommended = false,
  id,
  setPlanId,
  myPlanId,
}: any) => {
  const [showAll, setShowAll] = useState(false);

  const featsToShow = showAll ? feats : feats?.slice(0, 5);
  const BusubessTeam = title === "فريق كبير - Business Plan";
  const intl = useIntl();
  console.log(price, +price !== 700);

  return (
    <div
      className={`px-[24px] py-[32px] bg-white grid min-w-[290px] items-center w-fit text-start rounded-xl h-fit ${
        recommended ? "lg:-mt-10 max-lg:mt-8 !shadow-md" : "!bg-[#FBFBFF]"
      }`}
    >
      {recommended && (
        <div className="flex items-center justify-center gap-1 px-4 py-3 mx-auto mb-5 -mt-10 text-white rounded-full w-fit bg-color-primary">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.875 10.1891L9.15523 8.46973L8.09473 9.53023L10.875 12.3109L15.9052 7.28023L14.8447 6.21973L10.875 10.1891Z"
              fill="white"
            />
            <path
              d="M20.25 9C20.25 4.4445 16.5566 0.75 12 0.75C7.44487 0.75 3.75 4.4445 3.75 9C3.75 12.1579 5.526 14.9006 8.133 16.2874L7.5 23.25L12 20.25L16.5 23.25L15.867 16.2877C18.4744 14.901 20.25 12.1579 20.25 9ZM12 16.5C7.85775 16.5 4.5 13.1423 4.5 9C4.5 4.85775 7.85775 1.5 12 1.5C16.1423 1.5 19.5 4.85775 19.5 9C19.5 13.1423 16.1423 16.5 12 16.5Z"
              fill="white"
            />
          </svg>
          <span>{intl.formatMessage({ id: "recommended" })}</span>
        </div>
      )}
      {myPlanId === id && (
        <div className="py-3 px-4 text-lg font-semibold text-center rounded-lg bg-[#EEF0FF] text-color-primary">
          {intl.formatMessage({ id: "current" })}
        </div>
      )}
      <div className="text-[#75757E] text-lg border-solid border-b-[1px] border-[#9999A7] border-t-[0px] border-l-[0px] border-r-[0px] py-4 w-fit">
        {title}
      </div>
      {+price > 0 && +price !== 700 ? (
        <div className="my-6 text-4xl font-bold text-color-primary">
          {price}
          <span className="text-xs text-color-primary">
            {intl.formatMessage({ id: "per_month" })}
          </span>
        </div>
      ) : (
        <div className="flex items-center gap-1 my-6 text-4xl font-bold text-color-primary">
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.0001 6.5C25.8675 6.5 25.7403 6.44732 25.6465 6.35355C25.5527 6.25979 25.5001 6.13261 25.5001 6V5C25.5001 4.86739 25.5527 4.74021 25.6465 4.64645C25.7403 4.55268 25.8675 4.5 26.0001 4.5C26.1327 4.5 26.2599 4.55268 26.3536 4.64645C26.4474 4.74021 26.5001 4.86739 26.5001 5V6C26.5001 6.13261 26.4474 6.25979 26.3536 6.35355C26.2599 6.44732 26.1327 6.5 26.0001 6.5ZM25.0001 7.5H24.0001C23.8675 7.5 23.7403 7.44732 23.6465 7.35355C23.5527 7.25979 23.5001 7.13261 23.5001 7C23.5001 6.86739 23.5527 6.74021 23.6465 6.64645C23.7403 6.55268 23.8675 6.5 24.0001 6.5H25.0001C25.1327 6.5 25.2599 6.55268 25.3536 6.64645C25.4474 6.74021 25.5001 6.86739 25.5001 7C25.5001 7.13261 25.4474 7.25979 25.3536 7.35355C25.2599 7.44732 25.1327 7.5 25.0001 7.5ZM26.0001 9.5C25.8675 9.5 25.7403 9.44732 25.6465 9.35355C25.5527 9.25979 25.5001 9.13261 25.5001 9V8C25.5001 7.86739 25.5527 7.74021 25.6465 7.64645C25.7403 7.55268 25.8675 7.5 26.0001 7.5C26.1327 7.5 26.2599 7.55268 26.3536 7.64645C26.4474 7.74021 26.5001 7.86739 26.5001 8V9C26.5001 9.13261 26.4474 9.25979 26.3536 9.35355C26.2599 9.44732 26.1327 9.5 26.0001 9.5ZM28.0001 7.5H27.0001C26.8675 7.5 26.7403 7.44732 26.6465 7.35355C26.5527 7.25979 26.5001 7.13261 26.5001 7C26.5001 6.86739 26.5527 6.74021 26.6465 6.64645C26.7403 6.55268 26.8675 6.5 27.0001 6.5H28.0001C28.1327 6.5 28.2599 6.55268 28.3536 6.64645C28.4474 6.74021 28.5001 6.86739 28.5001 7C28.5001 7.13261 28.4474 7.25979 28.3536 7.35355C28.2599 7.44732 28.1327 7.5 28.0001 7.5ZM8.00007 24.5C7.86746 24.5 7.74028 24.4473 7.64651 24.3536C7.55275 24.2598 7.50007 24.1326 7.50007 24V23C7.50007 22.8674 7.55275 22.7402 7.64651 22.6464C7.74028 22.5527 7.86746 22.5 8.00007 22.5C8.13268 22.5 8.25985 22.5527 8.35362 22.6464C8.44739 22.7402 8.50007 22.8674 8.50007 23V24C8.50007 24.1326 8.44739 24.2598 8.35362 24.3536C8.25985 24.4473 8.13268 24.5 8.00007 24.5ZM7.00007 25.5H6.00007C5.86746 25.5 5.74028 25.4473 5.64651 25.3536C5.55275 25.2598 5.50007 25.1326 5.50007 25C5.50007 24.8674 5.55275 24.7402 5.64651 24.6464C5.74028 24.5527 5.86746 24.5 6.00007 24.5H7.00007C7.13268 24.5 7.25985 24.5527 7.35362 24.6464C7.44739 24.7402 7.50007 24.8674 7.50007 25C7.50007 25.1326 7.44739 25.2598 7.35362 25.3536C7.25985 25.4473 7.13268 25.5 7.00007 25.5ZM8.00007 27.5C7.86746 27.5 7.74028 27.4473 7.64651 27.3536C7.55275 27.2598 7.50007 27.1326 7.50007 27V26C7.50007 25.8674 7.55275 25.7402 7.64651 25.6464C7.74028 25.5527 7.86746 25.5 8.00007 25.5C8.13268 25.5 8.25985 25.5527 8.35362 25.6464C8.44739 25.7402 8.50007 25.8674 8.50007 26V27C8.50007 27.1326 8.44739 27.2598 8.35362 27.3536C8.25985 27.4473 8.13268 27.5 8.00007 27.5ZM10.0001 25.5H9.00007C8.86746 25.5 8.74028 25.4473 8.64651 25.3536C8.55275 25.2598 8.50007 25.1326 8.50007 25C8.50007 24.8674 8.55275 24.7402 8.64651 24.6464C8.74028 24.5527 8.86746 24.5 9.00007 24.5H10.0001C10.1327 24.5 10.2599 24.5527 10.3536 24.6464C10.4474 24.7402 10.5001 24.8674 10.5001 25C10.5001 25.1326 10.4474 25.2598 10.3536 25.3536C10.2599 25.4473 10.1327 25.5 10.0001 25.5ZM18.5001 29.5C18.3737 29.5004 18.2519 29.4529 18.1591 29.3671C18.0664 29.2812 18.0095 29.1635 18.0001 29.0375C17.9721 28.669 17.2166 19.984 8.38807 17.9875C8.27711 17.9627 8.1779 17.9009 8.1068 17.8122C8.0357 17.7235 7.99695 17.6132 7.99695 17.4995C7.99695 17.3858 8.0357 17.2755 8.1068 17.1868C8.1779 17.0981 8.27711 17.0363 8.38807 17.0115C17.2351 15.0115 17.9931 6.053 17.9996 5.9615C18.0093 5.83559 18.0663 5.71802 18.1591 5.63241C18.252 5.5468 18.3738 5.4995 18.5001 5.5C18.6265 5.49965 18.7484 5.54722 18.8412 5.63313C18.9339 5.71904 18.9907 5.83691 19.0001 5.963C19.0281 6.3315 19.7836 15.0165 28.6121 17.013C28.723 17.0378 28.8222 17.0996 28.8933 17.1883C28.9644 17.277 29.0032 17.3873 29.0032 17.501C29.0032 17.6147 28.9644 17.725 28.8933 17.8137C28.8222 17.9024 28.723 17.9642 28.6121 17.989C19.7651 19.989 19.0071 28.9475 19.0006 29.039C18.9907 29.1648 18.9337 29.2823 18.8408 29.3678C18.748 29.4533 18.6263 29.5005 18.5001 29.5ZM10.3001 17.5C15.5876 19.387 17.6856 23.7765 18.5001 26.5435C19.3146 23.7765 21.4126 19.387 26.7001 17.5C21.4126 15.613 19.3146 11.2235 18.5001 8.4565C17.6856 11.2235 15.5876 15.613 10.3001 17.5ZM5.50007 14.5C5.37442 14.5004 5.25322 14.4536 5.16057 14.3687C5.06792 14.2838 5.01062 14.1672 5.00007 14.042C4.88497 13.2658 4.52013 12.5482 3.96079 11.9979C3.40144 11.4476 2.67803 11.0945 1.90007 10.992C1.78649 10.9695 1.68423 10.9084 1.61074 10.8189C1.53725 10.7295 1.49707 10.6173 1.49707 10.5015C1.49707 10.3857 1.53725 10.2735 1.61074 10.1841C1.68423 10.0946 1.78649 10.0335 1.90007 10.011C2.67646 9.90457 3.3977 9.55015 3.95631 9.00055C4.51493 8.45094 4.88103 7.73556 5.00007 6.961C5.00981 6.83547 5.06656 6.71824 5.15897 6.63272C5.25138 6.5472 5.37266 6.4997 5.49857 6.4997C5.62448 6.4997 5.74575 6.5472 5.83816 6.63272C5.93057 6.71824 5.98732 6.83547 5.99707 6.961C6.11216 7.7372 6.477 8.45477 7.03635 9.00509C7.59569 9.55542 8.3191 9.90854 9.09707 10.011C9.21064 10.0335 9.3129 10.0946 9.38639 10.1841C9.45989 10.2735 9.50006 10.3857 9.50006 10.5015C9.50006 10.6173 9.45989 10.7295 9.38639 10.8189C9.3129 10.9084 9.21064 10.9695 9.09707 10.992C8.32067 11.0984 7.59944 11.4528 7.04082 12.0025C6.4822 12.5521 6.11611 13.2674 5.99707 14.042C5.98656 14.1667 5.92968 14.2829 5.83767 14.3677C5.74565 14.4525 5.62519 14.4997 5.50007 14.5ZM3.54607 10.5C4.38313 10.9235 5.06647 11.5986 5.50007 12.4305C5.93366 11.5986 6.617 10.9235 7.45407 10.5C6.617 10.0765 5.93366 9.40138 5.50007 8.5695C5.06647 9.40138 4.38313 10.0765 3.54607 10.5ZM27.5001 28.5C27.3744 28.5004 27.2532 28.4536 27.1606 28.3687C27.0679 28.2838 27.0106 28.1672 27.0001 28.042C26.8849 27.2658 26.52 26.5483 25.9607 25.998C25.4014 25.4477 24.678 25.0945 23.9001 24.992C23.7865 24.9695 23.6842 24.9084 23.6107 24.8189C23.5372 24.7295 23.4971 24.6173 23.4971 24.5015C23.4971 24.3857 23.5372 24.2735 23.6107 24.1841C23.6842 24.0946 23.7865 24.0335 23.9001 24.011C24.6765 23.9046 25.3978 23.5503 25.9564 23.0006C26.515 22.451 26.8811 21.7356 27.0001 20.961C27.0098 20.8355 27.0666 20.7182 27.159 20.6327C27.2514 20.5472 27.3727 20.4997 27.4986 20.4997C27.6245 20.4997 27.7458 20.5472 27.8382 20.6327C27.9306 20.7182 27.9873 20.8355 27.9971 20.961C28.1122 21.7372 28.4771 22.4547 29.0364 23.005C29.5958 23.5553 30.3191 23.9085 31.0971 24.011C31.2106 24.0335 31.3129 24.0946 31.3864 24.1841C31.4599 24.2735 31.5001 24.3857 31.5001 24.5015C31.5001 24.6173 31.4599 24.7295 31.3864 24.8189C31.3129 24.9084 31.2106 24.9695 31.0971 24.992C30.3206 25.0984 29.5994 25.4527 29.0407 26.0024C28.4821 26.552 28.116 27.2674 27.9971 28.042C27.9866 28.1667 27.9297 28.2829 27.8377 28.3677C27.7457 28.4525 27.6252 28.4997 27.5001 28.5ZM25.5461 24.5C26.3831 24.9235 27.0665 25.5986 27.5001 26.4305C27.9337 25.5986 28.617 24.9235 29.4541 24.5C28.617 24.0765 27.9337 23.4014 27.5001 22.5695C27.0665 23.4014 26.3831 24.0765 25.5461 24.5Z"
              fill="#00086D"
            />
          </svg>
          <span>{name}</span>
        </div>
      )}
      {BusubessTeam && (
        <div className="font-normal text-sm text-[#479821] w-full">
          {intl.formatMessage({ id: "all_features_plus" })}:
        </div>
      )}
      <List
        dataSource={featsToShow}
        renderItem={(item: any) => (
          <List.Item>
            <div className="flex items-center justify-start w-full gap-3 -m-2 text-sm">
              <span className="flex items-center justify-center">
                {RightSVG}
              </span>
              <div className="flex items-center gap-1">
                <span className="text-base font-medium">{item?.value}</span>
                <span className="text-base font-medium">{item?.name}</span>
              </div>
            </div>
          </List.Item>
        )}
      />
      {feats.length > 5 && (
        <div className="my-2 text-center">
          {!showAll ? (
            <Button type="text" onClick={() => setShowAll(true)}>
              <div className="flex items-center justify-center gap-2 text-xs font-semibold text-color-primary">
                {intl.formatMessage({ id: "show_all" })}
                <IoIosArrowDown className="font-semibold text-color-primary" />
              </div>
            </Button>
          ) : (
            <Button type="text" onClick={() => setShowAll(false)}>
              <div className="flex items-center justify-center gap-2 text-xs font-semibold text-color-primary">
                {intl.formatMessage({ id: "show_less" })}
                <IoIosArrowUp className="font-semibold text-color-primary" />
              </div>
            </Button>
          )}
        </div>
      )}
      {myPlanId === id ||
        (myPlanId && +price !== 700 && (
          <Button
            type="primary"
            htmlType="submit"
            className={`my-2 ${
              recommended
                ? "bg-color-primary"
                : "bg-white text-color-primary border-[1px] border-solid border-color-primary"
            }`}
            onClick={() => setPlanId(id)}
          >
            {price > 0
              ? intl.formatMessage({ id: "start_now" })
              : intl.formatMessage({ id: "start_free_now" })}
          </Button>
        ))}
      <List
        dataSource={commissions}
        renderItem={(item: any) => (
          <List.Item>
            <div className="flex items-center justify-start w-full gap-1 -m-2 whitespace-nowrap">
              <span className="flex items-center justify-center">
                {PlusSVG}
              </span>
              <span
                className={`text-xs ${
                  item.value > 0 ? "text-color-primary" : "text-[#479821]"
                } font-semibold`}
              >
                {item.value}%
              </span>
              <span className="text-xs text-[#75757E] font-semibold">
                {item.name}
              </span>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default PriceCard;
